import { defineStore } from 'pinia';

export const useStore = defineStore('root', {
    state: () => ({
        globalLoader: false as boolean,
        globalError: null as string | null,
        rootAppName: null as string | null,
        /** Breadcrumb tail declared by route meta — set by the router.afterEach guard. */
        routeSubAppName: null as string | null,
        /** Breadcrumb tail owned by a mounted component (`useSubAppName`); outranks the route's. */
        dynamicSubAppName: null as string | null,
        titleOverride: null as string | null,
        isMobile: false,
        isMobileReady: false
    }),

    getters: {
        /**
         * Breadcrumb tail. A component-owned name wins over the route's so that navigating within a
         * section that keeps that component mounted — e.g. the hosting site tabs, which all live
         * under `sites/:siteId` — doesn't drop the name the parent screen resolved.
         */
        subAppName(state): string | null {
            return state.dynamicSubAppName ?? state.routeSubAppName;
        }
    }
});
